<script setup>
import ListActivityLogs from '@/Pages/ListActivityLogs'
import { Inertia } from '@inertiajs/inertia';

const props = defineProps({
    items: {
        type: Array,
        required: true,
    },
});
function itemClicked(item){
    Inertia.visit('/activity-logs/' + item.id)
}
</script>

<template>
    <ListActivityLogs
		:items="items"
		@item-clicked="itemClicked"
	/>
</template>
